var _desc, _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u21B3 Icon Color",
    d: "M6.84 1.38L8.61 3.15L2.8 8.96C2.41 9.35 1.94 9.63 1.41 9.79L-0.04 10.24C-0.13 10.26 -0.22 10.21 -0.25 10.13C-0.26 10.09 -0.26 10.06 -0.25 10.03L0.2 8.58C0.36 8.05 0.64 7.58 1.03 7.19L6.84 1.38ZM9.32 -0.03L10.02 0.67C10.3 0.95 10.32 1.38 10.08 1.68L10.02 1.74L9.14 2.62L7.37 0.85L8.25 -0.03C8.55 -0.33 9.02 -0.33 9.32 -0.03Z",
    fill: "#FFFFFF",
    fillOpacity: 1,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditReview);
export default __webpack_public_path__ + "static/media/edit-review.65657fc518a412f98cab4f2fba5170eb.svg";
export { ForwardRef as ReactComponent };